<template>
  <div class="app-header">
    <div class="app-header-content">
      <div class="app-header-content-left" @click="$router.replace('/home')">
        <img src="@/assets/images/logo.png" alt="">
        <span>{{ title }}</span>
      </div>
      <div class="app-header-content-middle">
        <div
          v-show="windowWidth < 980 ? true : false"
          class="vertical_text"
          @click="isShowVerticalMenu = true"
          @mouseenter="isShowVerticalMenu = true"
        >{{ navList[activeIndex] ? navList[activeIndex].title : '控制台' }}</div>
        <el-menu
          v-show="windowWidth < 980 ? isShowVerticalMenu : true"
          :default-active="activeIndex"
          background-color="#304156"
          text-color="#909399"
          active-text-color="#f4f4f5"
          :router="true"
          :collapse-transition="false"
          :mode="windowWidth < 980 ? 'vertical' : 'horizontal'"
          :class="windowWidth < 980 ? 'verticalClass' : 'horizontalClass'"
        >
          <el-menu-item v-for="(item, index) in navList" :key="index" :index="String(index)" :route="item.link" @click="isControl = false; isShowVerticalMenu = false">
            <router-link class="router-link-color" style="font-size: 14px;" :to="handleIntoDetail(item)">{{ item.title }}</router-link>
          </el-menu-item>
        </el-menu>
      </div>
      <div class="app-header-content-right">
        <div class="control-btn">
          <el-button v-if="isControl || activeIndex === '-1'" class="no-click" type="primary" size="mini">控制台</el-button>
          <span v-else @click="handleJumpToControl">控制台</span>
        </div>
        <el-dropdown>
          <div v-if="name" style="cursor: pointer; color: #f4f4f5">{{ name }}</div>
          <div v-else style="cursor:pointer; color: #909399;" @click="handleLogin">登录</div>
          <el-dropdown-menu v-if="name" slot="dropdown">
            <el-dropdown-item divided @click.native="handleLoginOut">
              <span style="display:block;">退出</span>
            </el-dropdown-item>
          </el-dropdown-menu>
          <el-dropdown-menu v-else class="self-dropdown-menu" />
        </el-dropdown>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  data() {
    return {
      activeIndex: '0',
      windowWidth: document.documentElement.clientWidth,
      isControl: false,
      navList: [{
        'title': '首页',
        'link': '/'
      },
      {
        'title': '资源招募',
        'link': '/recruit'
      },
      {
        'title': '帮助中心',
        'link': '/help'
      },
      {
        'title': '下载中心',
        'link': '/download'
      },
      {
        'title': '业务咨询',
        'link': '/consult'
      }],
      isShowVerticalMenu: false
    }
  },
  computed: {
    ...mapGetters(['title', 'name'])
  },
  watch: {
    $route: {
      handler: function(to, from) {
        this.activeIndex = to.meta.activeIndex || '-1'
        if (this.activeIndex === '-1') {
          this.isControl = true
        } else {
          this.isControl = false
        }
      },
      // 深度观察监听
      deep: true,
      immediate: true
    }
  },
  mounted() {
    window.addEventListener('resize', () => {
      this.windowWidth = document.documentElement.clientWidth
    })
    window.addEventListener('mouseover', (e) => {
      const menuEle = document.querySelector('.el-menu')
      if (menuEle.contains(e.target)) {
        this.isShowVerticalMenu = true
      } else {
        this.isShowVerticalMenu = false
      }
    })
  },
  destroyed() {
    window.removeEventListener('resize', () => {})
    window.removeEventListener('mouseover', () => {})
  },
  methods: {
    handleIntoDetail(row) {
      return this.$globalRouter(row.link)
    },
    handleJumpToControl() {
      if (this.name) {
        this.activeIndex = '-1'
        this.isControl = true
        this.$router.push('/agreement')
      } else {
        window.location.href = `https://sso.jdcloud.com/sso/login?ReturnUrl=${window.location.origin}`
      }
    },
    handleLogin() {
      window.location.href = `https://sso.jdcloud.com/sso/login?ReturnUrl=${window.location.origin}`
    },
    handleLoginOut() {
      this.$store.dispatch('user/resetThor')
        .then(() => {
          this.$store.dispatch('user/getUserInfo')
          this.$router.replace('/home')
        })
    }
  }
}
</script>

<style lang="scss" scoped>
.app-header {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 2000;
  max-width: 100%!important;
  height: 55px;
  background-color: #304156;
  .app-header-content {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    height: 100%;
    padding: 0 15px;
    box-sizing: border-box;
    &-left{
      display: flex;
      align-items: center;
      flex-shrink: 0;
      font-size: 18px;
      color:#f4f4f5;
      cursor: pointer;
      img {
        width: 50px;
        height: 50px;
        margin-top: -5px;
        margin-right: 5px;
      }
    }
    &-middle {
      position: relative;
      display: flex;
      justify-content: center;
      align-items: center;
      width: 100%;
      height: 100%;
      .vertical_text {
        display: flex;
        align-items: center;
        min-width: 96px;
        height: 100%;
        padding: 0 20px;
        box-sizing: border-box;
        font-size: 14px;
        color: #f4f4f5;
        cursor: pointer;
      }
    }
    &-right {
      display: flex;
      align-items: center;
      flex-shrink: 0;
      height: 40px;
      line-height: 40px;
      .control-btn {
        margin-right: 25px;
        font-size: 14px;
        color: #909399;
        cursor: pointer;
        .no-click {
          cursor: auto;
        }
      }
    }
  }
}

::v-deep .horizontalClass {
  border-bottom: none!important;
  .el-menu-item {
    height: 40px!important;
    padding: 0!important;
    margin: 0 20px!important;
    background: none!important;
    line-height: 40px!important;
    &:hover {
      background: none!important;
      color:  #f4f4f5!important;
    }
  }
}
::v-deep .verticalClass {
  position: absolute;
  top: 55px;
  left: 50%;
  transform: translateX(-50%);
  width: 96px;
  border-right: none!important;
}
</style>

<style lang="scss">
.self-dropdown-menu {
  display: none!important;
}
</style>
